import React from 'react';
import PropTypes from 'prop-types';

import {Box, MenuItem, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography} from 'views/components';
import {ExpandMore} from 'views/icons';
import {Translate, translate} from 'views/module';

const PlaybooksNewGroup = (props) => {
  const {existingGroup, groupMode, groupOptions, newGroupName, setExistingGroup, setGroupMode, setNewGroupName} = props;
  const hasExistingGroups = groupOptions.length > 0;

  return (
    <Stack sx={{gap: '10px'}}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#A8A49E',
          lineHeight: '100%',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='playbooks.New.GroupLabel' />
      </Typography>
      <Box
        sx={{
          display: 'inline-flex',
          width: 'fit-content',
          p: '5px',
          borderRadius: '12px',
          backgroundColor: '#F3F1EE',
        }}
      >
        <ToggleButtonGroup
          exclusive
          value={groupMode}
          onChange={(_event, value) => {
            if (value) {
              setGroupMode(value);
            }
          }}
          sx={{
            'gap': '4px',
            '& .MuiToggleButtonGroup-grouped': {
              border: '0',
              borderRadius: '9px !important',
            },
          }}
        >
          <ToggleButton
            value='existing'
            disabled={!hasExistingGroups}
            sx={{
              'px': '12px',
              'py': '14px',
              'fontSize': '14px',
              'fontWeight': 500,
              'lineHeight': '100%',
              'textTransform': 'none',
              'color': '#1A1916',
              'backgroundColor': 'transparent',
              'boxShadow': 'none',
              '&.Mui-selected': {
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 2px 8px rgba(26, 25, 22, 0.10)',
              },
              '&.Mui-selected:hover': {
                backgroundColor: '#FFFFFF',
              },
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Translate expression='playbooks.New.GroupMode.Existing' />
          </ToggleButton>
          <ToggleButton
            value='new'
            sx={{
              'px': '12px',
              'py': '14px',
              'fontSize': '14px',
              'fontWeight': 500,
              'lineHeight': '100%',
              'textTransform': 'none',
              'color': '#1A1916',
              'backgroundColor': 'transparent',
              'boxShadow': 'none',
              '&.Mui-selected': {
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 2px 8px rgba(26, 25, 22, 0.10)',
              },
              '&.Mui-selected:hover': {
                backgroundColor: '#FFFFFF',
              },
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Translate expression='playbooks.New.GroupMode.New' />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {
        groupMode === 'existing' &&
        hasExistingGroups &&
        <TextField
          select
          fullWidth
          value={existingGroup}
          onChange={setExistingGroup}
          SelectProps={{
            IconComponent: ExpandMore,
            renderValue: (value) => value,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              'borderRadius': '12px',
            },
            '& .MuiSelect-select': {
              px: '16px',
              py: '14px',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#1A1916',
              boxSizing: 'border-box',
            },
            '& .MuiSelect-icon': {
              color: '#1A1916',
              right: '14px',
            },
          }}
        >
          {
            groupOptions.map((groupOption) => (
              <MenuItem
                key={groupOption}
                value={groupOption}
              >
                {groupOption}
              </MenuItem>
            ))
          }
        </TextField>
      }
      {
        groupMode === 'new' &&
        <TextField
          value={newGroupName}
          onChange={setNewGroupName}
          placeholder={translate('playbooks.New.NewGroupPlaceholder')}
          sx={{
            '& .MuiOutlinedInput-root': {
              'borderRadius': '12px',
            },
            '& .MuiOutlinedInput-input': {
              px: '16px',
              py: '24px',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '150%',
              color: '#1A1916',
              boxSizing: 'border-box',
            },
            '& .MuiOutlinedInput-input::placeholder': {
              color: '#A8A49E',
              opacity: 1,
            },
          }}
        />
      }
    </Stack>
  );
};

PlaybooksNewGroup.propTypes = {
  existingGroup: PropTypes.string.isRequired,
  groupMode: PropTypes.string.isRequired,
  groupOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  newGroupName: PropTypes.string.isRequired,
  setExistingGroup: PropTypes.func.isRequired,
  setGroupMode: PropTypes.func.isRequired,
  setNewGroupName: PropTypes.func.isRequired,
};

export default React.memo(PlaybooksNewGroup);
